import BottomSheet from '@/components/Common/DesignSystem/BottomSheet/BottomSheet';
import BottomSheetCustomContents from '@/components/Common/DesignSystem/BottomSheet/Contents/BottomSheetCustomContents';
import Checkbox from '@/components/Common/DesignSystem/Checkbox/Checkbox';
import { Kinesis } from '@/services/TrackerService';
import { MarketingTermsStore } from '@/stores/partial/MarketingTermsStore';
import { observer } from 'mobx-react-lite';
import dynamic from 'next/dynamic';
import { pipe } from 'ramda';
import React from 'react';

import styles from './MarketingTerms.module.scss';

const TermModal = dynamic(() => import('./TermModal/MarketingTermModal'));

interface IMarketingTermsProps {
  pageName: string;
  store: MarketingTermsStore;
}

const MarketingTerms: React.FC<IMarketingTermsProps> = ({ pageName, store }) => {
  const logCloseRequested = (): Promise<void> =>
    Kinesis.click(pageName, {
      object: 'closeBtn',
      objectContainer: 'pushOnPopup',
      specialPromotionName: store.specialPromotionName,
      promotionStatus: store.promotionStatus,
    });

  const logSubmit = (): Promise<void> =>
    Kinesis.click(pageName, {
      object: 'pushMessageOn',
      objectContainer: 'pushOnPopup',
      specialPromotionName: store.specialPromotionName,
      promotionStatus: store.promotionStatus,
    });

  return (
    <BottomSheet isOpen={store.isOpen} onRequestClose={pipe(store.close, logCloseRequested)}>
      {{
        title: '마케팅 수신동의',
        body: (
          <BottomSheetCustomContents>
            <ul className={styles.termList}>
              <li>
                이벤트 · 혜택 Push 알림 동의하고 <strong>NOL의 쿠폰, 할인, 특가 등의 혜택 소식</strong>을 빠르게
                받아보세요!
              </li>
              {!store.marketingPrivacy && (
                <li className={styles.term}>
                  <button
                    className={styles.toggle}
                    role="checkbox"
                    type="button"
                    onClick={store.toggleMarketingPrivacyTerm}
                    aria-checked={store.isAgreeMarketingPrivacy}
                  >
                    <Checkbox className={styles.toggleCheck} checked={store.isAgreeMarketingPrivacy} />
                  </button>
                  <span className={styles.toggleLabel}>
                    <a className={styles.label} onClick={() => store.openTermModal()}>
                      개인정보 수집 및 이용 동의 (선택)
                    </a>
                    <span className={styles.caption}>서비스 혜택 등의 정보 제공을 위한 개인정보 수집 및 활용 </span>
                  </span>

                  <TermModal
                    isOpen={store.isTermModalOpen}
                    title="개인정보 수집 및 이용 동의"
                    term={store.marketingPrivacyTerm}
                    onClose={store.closeTerm}
                  />
                </li>
              )}
            </ul>
          </BottomSheetCustomContents>
        ),
        buttons: {
          type: 'confirm',
          disabled: !store.Submittable,
          label: '동의하고 혜택 받기',
          style: 'primary',
          onClick: pipe(store.agree, logSubmit),
        },
      }}
    </BottomSheet>
  );
};

export default observer(MarketingTerms);
